// extracted by mini-css-extract-plugin
export default {"cover":"cover___llSPY","coverEdit":"coverEdit___GtifC","FInput":"FInput___msUZR","btn":"btn___l1eSs"};